export const ApoCharacterData = [
  {
    char: 'acheron',
    name: 'Acheron',
    current_app_rate: 7.75,
    app_eidolons: 5.99,
    app_free: 0.09,
    current_avg_score: 3318,
    round_eidolons: 3505,
    round_free: 3257,
    prev_app_rate: 24.77,
    prev_avg_score: 3334,
    rarity: 'Limited 5*'
  },
  {
    char: 'aglaea',
    name: 'Aglaea',
    current_app_rate: 1.36,
    app_eidolons: 1.2,
    app_free: 0,
    current_avg_score: 3344,
    round_eidolons: 3465,
    round_free: 0,
    prev_app_rate: 16.06,
    prev_avg_score: 3474,
    rarity: 'Limited 5*'
  },
  {
    char: 'anaxa',
    name: 'Anaxa',
    current_app_rate: 3.96,
    app_eidolons: 2.22,
    app_free: 0.5,
    current_avg_score: 3579,
    round_eidolons: 3712,
    round_free: 3569,
    prev_app_rate: 3.96,
    prev_avg_score: 3579,
    rarity: 'Limited 5*'
  },
  {
    char: 'argenti',
    name: 'Argenti',
    current_app_rate: 2.45,
    app_eidolons: 1.27,
    app_free: 0.37,
    current_avg_score: 3478,
    round_eidolons: 3521,
    round_free: 3430,
    prev_app_rate: 3.17,
    prev_avg_score: 3573,
    rarity: 'Limited 5*'
  },
  {
    char: 'arlan',
    name: 'Arlan',
    current_app_rate: 0,
    app_eidolons: 0,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.01,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    char: 'asta',
    name: 'Asta',
    current_app_rate: 0.14,
    app_eidolons: 0.1,
    app_free: 0.01,
    current_avg_score: 0,
    round_eidolons: 3538,
    round_free: 0,
    prev_app_rate: 0.16,
    prev_avg_score: 3402,
    rarity: '4*'
  },
  {
    char: 'aventurine',
    name: 'Aventurine',
    current_app_rate: 35.87,
    app_eidolons: 16.56,
    app_free: 6.86,
    current_avg_score: 3400,
    round_eidolons: 3485,
    round_free: 3374,
    prev_app_rate: 49.24,
    prev_avg_score: 3418,
    rarity: 'Limited 5*'
  },
  {
    char: 'bailu',
    name: 'Bailu',
    current_app_rate: 0.76,
    app_eidolons: 0.39,
    app_free: 0.06,
    current_avg_score: 3424,
    round_eidolons: 3472,
    round_free: 0,
    prev_app_rate: 0.94,
    prev_avg_score: 3337,
    rarity: 'Standard 5*'
  },
  {
    char: 'black-swan',
    name: 'Black Swan',
    current_app_rate: 0.17,
    app_eidolons: 0.15,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 3239,
    round_free: 0,
    prev_app_rate: 5.16,
    prev_avg_score: 3224,
    rarity: 'Limited 5*'
  },
  {
    char: 'blade',
    name: 'Blade',
    current_app_rate: 2.39,
    app_eidolons: 1.38,
    app_free: 0.18,
    current_avg_score: 3397,
    round_eidolons: 3440,
    round_free: 3312,
    prev_app_rate: 1.77,
    prev_avg_score: 3365,
    rarity: 'Limited 5*'
  },
  {
    char: 'boothill',
    name: 'Boothill',
    current_app_rate: 4.83,
    app_eidolons: 3.18,
    app_free: 0.45,
    current_avg_score: 3442,
    round_eidolons: 3575,
    round_free: 3415,
    prev_app_rate: 6.23,
    prev_avg_score: 3483,
    rarity: 'Limited 5*'
  },
  {
    char: 'bronya',
    name: 'Bronya',
    current_app_rate: 4.32,
    app_eidolons: 2.81,
    app_free: 0.34,
    current_avg_score: 3418,
    round_eidolons: 3552,
    round_free: 3417,
    prev_app_rate: 10.23,
    prev_avg_score: 3531,
    rarity: 'Standard 5*'
  },
  {
    char: 'castorice',
    name: 'Castorice',
    current_app_rate: 61.59,
    app_eidolons: 31.26,
    app_free: 3.56,
    current_avg_score: 3513,
    round_eidolons: 3642,
    round_free: 3434,
    prev_app_rate: 65.06,
    prev_avg_score: 3654,
    rarity: 'Limited 5*'
  },
  {
    char: 'clara',
    name: 'Clara',
    current_app_rate: 0.81,
    app_eidolons: 0.59,
    app_free: 0.05,
    current_avg_score: 3186,
    round_eidolons: 3271,
    round_free: 0,
    prev_app_rate: 0.51,
    prev_avg_score: 3213,
    rarity: 'Standard 5*'
  },
  {
    char: 'dan-heng',
    name: 'Dan Heng',
    current_app_rate: 0.05,
    app_eidolons: 0.03,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.08,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    char: 'dr-ratio',
    name: 'Dr. Ratio',
    current_app_rate: 0.13,
    app_eidolons: 0.09,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 3290,
    round_free: 0,
    prev_app_rate: 0.28,
    prev_avg_score: 3100,
    rarity: 'Limited 5*'
  },
  {
    char: 'feixiao',
    name: 'Feixiao',
    current_app_rate: 23.95,
    app_eidolons: 11.14,
    app_free: 5.53,
    current_avg_score: 3396,
    round_eidolons: 3504,
    round_free: 3369,
    prev_app_rate: 37.01,
    prev_avg_score: 3439,
    rarity: 'Limited 5*'
  },
  {
    char: 'firefly',
    name: 'Firefly',
    current_app_rate: 15.35,
    app_eidolons: 13.29,
    app_free: 0.82,
    current_avg_score: 3243,
    round_eidolons: 3457,
    round_free: 3227,
    prev_app_rate: 15.56,
    prev_avg_score: 3248,
    rarity: 'Limited 5*'
  },
  {
    char: 'fu-xuan',
    name: 'Fu Xuan',
    current_app_rate: 12.22,
    app_eidolons: 7.39,
    app_free: 1.5,
    current_avg_score: 3376,
    round_eidolons: 3450,
    round_free: 3336,
    prev_app_rate: 16.83,
    prev_avg_score: 3386,
    rarity: 'Limited 5*'
  },
  {
    char: 'gallagher',
    name: 'Gallagher',
    current_app_rate: 46.18,
    app_eidolons: 23.33,
    app_free: 3.95,
    current_avg_score: 3481,
    round_eidolons: 3568,
    round_free: 3393,
    prev_app_rate: 24.39,
    prev_avg_score: 3394,
    rarity: '4*'
  },
  {
    char: 'gepard',
    name: 'Gepard',
    current_app_rate: 0.26,
    app_eidolons: 0.17,
    app_free: 0.03,
    current_avg_score: 3290,
    round_eidolons: 3406,
    round_free: 0,
    prev_app_rate: 0.89,
    prev_avg_score: 3356,
    rarity: 'Standard 5*'
  },
  {
    char: 'guinaifen',
    name: 'Guinaifen',
    current_app_rate: 0.01,
    app_eidolons: 0,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.33,
    prev_avg_score: 3284,
    rarity: '4*'
  },
  {
    char: 'hanya',
    name: 'Hanya',
    current_app_rate: 0.03,
    app_eidolons: 0.03,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.11,
    prev_avg_score: 3388,
    rarity: '4*'
  },
  {
    char: 'herta',
    name: 'Herta',
    current_app_rate: 26.09,
    app_eidolons: 11,
    app_free: 5.1,
    current_avg_score: 3427,
    round_eidolons: 3557,
    round_free: 3382,
    prev_app_rate: 28.12,
    prev_avg_score: 3484,
    rarity: '4*'
  },
  {
    char: 'himeko',
    name: 'Himeko',
    current_app_rate: 0.21,
    app_eidolons: 0.14,
    app_free: 0.01,
    current_avg_score: 3287,
    round_eidolons: 3367,
    round_free: 0,
    prev_app_rate: 1.25,
    prev_avg_score: 3420,
    rarity: 'Standard 5*'
  },
  {
    char: 'hook',
    name: 'Hook',
    current_app_rate: 0.02,
    app_eidolons: 0.01,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.02,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    char: 'huohuo',
    name: 'Huohuo',
    current_app_rate: 16.72,
    app_eidolons: 8.64,
    app_free: 2.28,
    current_avg_score: 3412,
    round_eidolons: 3491,
    round_free: 3376,
    prev_app_rate: 26.65,
    prev_avg_score: 3432,
    rarity: 'Limited 5*'
  },
  {
    char: 'imbibitor-lunae',
    name: 'Imbibitor Lunae',
    current_app_rate: 0.41,
    app_eidolons: 0.39,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 3325,
    round_free: 0,
    prev_app_rate: 0.84,
    prev_avg_score: 0,
    rarity: 'Limited 5*'
  },
  {
    char: 'jade',
    name: 'Jade',
    current_app_rate: 18.36,
    app_eidolons: 8.75,
    app_free: 3.24,
    current_avg_score: 3473,
    round_eidolons: 3575,
    round_free: 3429,
    prev_app_rate: 20.77,
    prev_avg_score: 3596,
    rarity: 'Limited 5*'
  },
  {
    char: 'jiaoqiu',
    name: 'Jiaoqiu',
    current_app_rate: 7.81,
    app_eidolons: 5.79,
    app_free: 0.11,
    current_avg_score: 3345,
    round_eidolons: 3527,
    round_free: 3308,
    prev_app_rate: 14.44,
    prev_avg_score: 3380,
    rarity: 'Limited 5*'
  },
  {
    char: 'jing-yuan',
    name: 'Jing Yuan',
    current_app_rate: 0.2,
    app_eidolons: 0.16,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 3328,
    round_free: 0,
    prev_app_rate: 10.5,
    prev_avg_score: 3374,
    rarity: 'Limited 5*'
  },
  {
    char: 'jingliu',
    name: 'Jingliu',
    current_app_rate: 0.17,
    app_eidolons: 0.12,
    app_free: 0.02,
    current_avg_score: 0,
    round_eidolons: 3296,
    round_free: 0,
    prev_app_rate: 2.26,
    prev_avg_score: 3327,
    rarity: 'Limited 5*'
  },
  {
    char: 'kafka',
    name: 'Kafka',
    current_app_rate: 0.1,
    app_eidolons: 0.1,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 3203,
    round_free: 0,
    prev_app_rate: 4.9,
    prev_avg_score: 3230,
    rarity: 'Limited 5*'
  },
  {
    char: 'lingsha',
    name: 'Lingsha',
    current_app_rate: 29.54,
    app_eidolons: 18.07,
    app_free: 3.63,
    current_avg_score: 3434,
    round_eidolons: 3521,
    round_free: 3381,
    prev_app_rate: 39.95,
    prev_avg_score: 3487,
    rarity: 'Limited 5*'
  },
  {
    char: 'luka',
    name: 'Luka',
    current_app_rate: 0.05,
    app_eidolons: 0.03,
    app_free: 0.02,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.09,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    char: 'luocha',
    name: 'Luocha',
    current_app_rate: 26.12,
    app_eidolons: 14.13,
    app_free: 1.95,
    current_avg_score: 3472,
    round_eidolons: 3585,
    round_free: 3398,
    prev_app_rate: 10.3,
    prev_avg_score: 3410,
    rarity: 'Limited 5*'
  },
  {
    char: 'lynx',
    name: 'Lynx',
    current_app_rate: 0.53,
    app_eidolons: 0.27,
    app_free: 0.05,
    current_avg_score: 3357,
    round_eidolons: 3486,
    round_free: 0,
    prev_app_rate: 0.3,
    prev_avg_score: 3342,
    rarity: '4*'
  },
  {
    char: 'march-7th',
    name: 'March 7th',
    current_app_rate: 0.06,
    app_eidolons: 0.05,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.13,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    char: 'march-7th-swordmaster',
    name: 'March 7th - The Hunt',
    current_app_rate: 11.44,
    app_eidolons: 4.4,
    app_free: 3.37,
    current_avg_score: 3412,
    round_eidolons: 3527,
    round_free: 3384,
    prev_app_rate: 19.72,
    prev_avg_score: 3473,
    rarity: '4*'
  },
  {
    char: 'misha',
    name: 'Misha',
    current_app_rate: 0,
    app_eidolons: 0,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.07,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    char: 'moze',
    name: 'Moze',
    current_app_rate: 0.58,
    app_eidolons: 0.29,
    app_free: 0.1,
    current_avg_score: 3305,
    round_eidolons: 3426,
    round_free: 3262,
    prev_app_rate: 2.77,
    prev_avg_score: 3338,
    rarity: '4*'
  },
  {
    char: 'mydei',
    name: 'Mydei',
    current_app_rate: 11.19,
    app_eidolons: 5.94,
    app_free: 0.85,
    current_avg_score: 3439,
    round_eidolons: 3560,
    round_free: 3381,
    prev_app_rate: 1.97,
    prev_avg_score: 3377,
    rarity: 'Limited 5*'
  },
  {
    char: 'natasha',
    name: 'Natasha',
    current_app_rate: 0.03,
    app_eidolons: 0.01,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.07,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    char: 'pela',
    name: 'Pela',
    current_app_rate: 5.51,
    app_eidolons: 2.84,
    app_free: 0.24,
    current_avg_score: 3353,
    round_eidolons: 3483,
    round_free: 3290,
    prev_app_rate: 13.33,
    prev_avg_score: 3363,
    rarity: '4*'
  },
  {
    char: 'qingque',
    name: 'Qingque',
    current_app_rate: 0.1,
    app_eidolons: 0.09,
    app_free: 0.01,
    current_avg_score: 0,
    round_eidolons: 3284,
    round_free: 0,
    prev_app_rate: 0.15,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    char: 'rappa',
    name: 'Rappa',
    current_app_rate: 3.45,
    app_eidolons: 2.43,
    app_free: 0.3,
    current_avg_score: 3303,
    round_eidolons: 3423,
    round_free: 3242,
    prev_app_rate: 11.21,
    prev_avg_score: 3395,
    rarity: 'Limited 5*'
  },
  {
    char: 'robin',
    name: 'Robin',
    current_app_rate: 41.65,
    app_eidolons: 21.77,
    app_free: 7.42,
    current_avg_score: 3397,
    round_eidolons: 3516,
    round_free: 3368,
    prev_app_rate: 62.39,
    prev_avg_score: 3447,
    rarity: 'Limited 5*'
  },
  {
    char: 'ruan-mei',
    name: 'Ruan Mei',
    current_app_rate: 55.77,
    app_eidolons: 40.09,
    app_free: 3.48,
    current_avg_score: 3453,
    round_eidolons: 3543,
    round_free: 3349,
    prev_app_rate: 39.61,
    prev_avg_score: 3399,
    rarity: 'Limited 5*'
  },
  {
    char: 'sampo',
    name: 'Sampo',
    current_app_rate: 0.05,
    app_eidolons: 0.04,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.09,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    char: 'seele',
    name: 'Seele',
    current_app_rate: 0.89,
    app_eidolons: 0.68,
    app_free: 0.04,
    current_avg_score: 3382,
    round_eidolons: 3440,
    round_free: 0,
    prev_app_rate: 0.91,
    prev_avg_score: 3548,
    rarity: 'Limited 5*'
  },
  {
    char: 'serval',
    name: 'Serval',
    current_app_rate: 2.9,
    app_eidolons: 1.5,
    app_free: 0.43,
    current_avg_score: 3406,
    round_eidolons: 3543,
    round_free: 3371,
    prev_app_rate: 14.37,
    prev_avg_score: 3535,
    rarity: '4*'
  },
  {
    char: 'silver-wolf',
    name: 'Silver Wolf',
    current_app_rate: 0.94,
    app_eidolons: 0.68,
    app_free: 0.01,
    current_avg_score: 3268,
    round_eidolons: 3406,
    round_free: 0,
    prev_app_rate: 2.54,
    prev_avg_score: 3285,
    rarity: 'Limited 5*'
  },
  {
    char: 'sparkle',
    name: 'Sparkle',
    current_app_rate: 6.73,
    app_eidolons: 4.98,
    app_free: 0.34,
    current_avg_score: 3364,
    round_eidolons: 3477,
    round_free: 3318,
    prev_app_rate: 12.16,
    prev_avg_score: 3364,
    rarity: 'Limited 5*'
  },
  {
    char: 'sunday',
    name: 'Sunday',
    current_app_rate: 30.99,
    app_eidolons: 17.19,
    app_free: 2.13,
    current_avg_score: 3450,
    round_eidolons: 3565,
    round_free: 3375,
    prev_app_rate: 41.73,
    prev_avg_score: 3454,
    rarity: 'Limited 5*'
  },
  {
    char: 'sushang',
    name: 'Sushang',
    current_app_rate: 0.05,
    app_eidolons: 0.03,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.22,
    prev_avg_score: 3436,
    rarity: '4*'
  },
  {
    char: 'the-herta',
    name: 'The Herta',
    current_app_rate: 49.28,
    app_eidolons: 21.66,
    app_free: 9.28,
    current_avg_score: 3449,
    round_eidolons: 3572,
    round_free: 3403,
    prev_app_rate: 63.94,
    prev_avg_score: 3526,
    rarity: 'Limited 5*'
  },
  {
    char: 'tingyun',
    name: 'Tingyun',
    current_app_rate: 1.21,
    app_eidolons: 0.85,
    app_free: 0.08,
    current_avg_score: 3374,
    round_eidolons: 3564,
    round_free: 3363,
    prev_app_rate: 2.29,
    prev_avg_score: 3339,
    rarity: '4*'
  },
  {
    char: 'tingyun-fugue',
    name: 'Fugue',
    current_app_rate: 20.86,
    app_eidolons: 16.82,
    app_free: 1.3,
    current_avg_score: 3342,
    round_eidolons: 3501,
    round_free: 3295,
    prev_app_rate: 26.4,
    prev_avg_score: 3406,
    rarity: 'Limited 5*'
  },
  {
    char: 'topaz',
    name: 'Topaz & Numby',
    current_app_rate: 10.92,
    app_eidolons: 5.74,
    app_free: 2,
    current_avg_score: 3370,
    round_eidolons: 3463,
    round_free: 3337,
    prev_app_rate: 12.01,
    prev_avg_score: 3386,
    rarity: 'Limited 5*'
  },
  {
    char: 'trailblazer-destruction',
    name: 'Trailblazer - Destruction',
    current_app_rate: 0.01,
    app_eidolons: 0.01,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    char: 'trailblazer-harmony',
    name: 'Trailblazer - Harmony',
    current_app_rate: 5.88,
    app_eidolons: 4.62,
    app_free: 0.54,
    current_avg_score: 3269,
    round_eidolons: 3440,
    round_free: 3228,
    prev_app_rate: 10.34,
    prev_avg_score: 3343,
    rarity: '4*'
  },
  {
    char: 'trailblazer-preservation',
    name: 'Trailblazer - Preservation',
    current_app_rate: 0,
    app_eidolons: 0,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.01,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    char: 'trailblazer-remembrance',
    name: 'Trailblazer - Remembrance',
    current_app_rate: 67.5,
    app_eidolons: 32.33,
    app_free: 5.34,
    current_avg_score: 3503,
    round_eidolons: 3633,
    round_free: 3423,
    prev_app_rate: 39.87,
    prev_avg_score: 3506,
    rarity: '4*'
  },
  {
    char: 'tribbie',
    name: 'Tribbie',
    current_app_rate: 60.36,
    app_eidolons: 29.11,
    app_free: 7.1,
    current_avg_score: 3518,
    round_eidolons: 3640,
    round_free: 3463,
    prev_app_rate: 44.19,
    prev_avg_score: 3547,
    rarity: 'Limited 5*'
  },
  {
    char: 'welt',
    name: 'Welt',
    current_app_rate: 0.04,
    app_eidolons: 0.03,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.18,
    prev_avg_score: 3241,
    rarity: 'Standard 5*'
  },
  {
    char: 'xueyi',
    name: 'Xueyi',
    current_app_rate: 0.17,
    app_eidolons: 0.13,
    app_free: 0.01,
    current_avg_score: 0,
    round_eidolons: 3463,
    round_free: 0,
    prev_app_rate: 0.02,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    char: 'yanqing',
    name: 'Yanqing',
    current_app_rate: 0.01,
    app_eidolons: 0.01,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.16,
    prev_avg_score: 0,
    rarity: 'Standard 5*'
  },
  {
    char: 'yukong',
    name: 'Yukong',
    current_app_rate: 0.01,
    app_eidolons: 0.01,
    app_free: 0.01,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    char: 'yunli',
    name: 'Yunli',
    current_app_rate: 4.44,
    app_eidolons: 2.76,
    app_free: 0.35,
    current_avg_score: 3273,
    round_eidolons: 3399,
    round_free: 3238,
    prev_app_rate: 3.82,
    prev_avg_score: 3287,
    rarity: 'Limited 5*'
  }
];
